<div class="fee-per-weekday-container">
  <form [formGroup]="formGroup">
    <div formGroupName="feePerWeekday">
      <pdq-checkbox
        labelSize="medium"
        formControlName="enabled"
        (onChange)="onToggle($event)"
        [checked]="formGroup.value.feePerWeekday.enabled"
        [secondaryLabel]="
          formGroup.value.feePerWeekday.enabled
            ? 'Selecting the same day multiple times will display the highest cost.'
            : ''
        "
        label="Add cost by delivery date"></pdq-checkbox>
      @if (formGroup.value.feePerWeekday.enabled) {
        <div>
          <div class="rules-list">
            <div class="column" [formArrayName]="formArrayFieldName">
              @for (control of getFormArray().controls; track control; let i = $index) {
                <div>
                  <div
                    [ngClass]="control.value?.weekday === ExtendedWeekdays.DaysAfterHolidays ? 'column' : 'row'"
                    [formGroupName]="i">
                    <div class="row">
                      <pdq-dropdown
                        title="Weekday"
                        formControlName="weekday"
                        placeholder="Select your weekday"
                        [options]="weekdayOptions | decreaseWeekDayOption: getFormArray().value"
                        [defaultOption]="getDefaultOption(weekdayOptions, control.value?.weekday)"></pdq-dropdown>
                      @if (control.value?.weekday === ExtendedWeekdays.DaysAfterHolidays) {
                        <pdq-input-arrows
                          label="Number of days"
                          formControlName="numOfDays"
                          min="0"
                          widthSize="auto"
                          width="120"></pdq-input-arrows>
                        <div formGroupName="nationalHolidays">
                          <pdq-dropdown
                            title="Select holidays"
                            formControlName="country"
                            placeholder="Select holidays"
                            [options]="holidaysOptions"
                            [defaultOption]="
                              getDefaultOption(holidaysOptions, control.get('nationalHolidays.country')?.value)
                            "
                            [invalid]="control.get('nationalHolidays.country')?.errors?.required"></pdq-dropdown>
                        </div>
                      }

                      @if (control.value?.weekday === ExtendedWeekdays.X_DAYS_FROM_TODAY) {
                        <pdq-input-arrows
                          label="Number of days"
                          formControlName="numOfDays"
                          min="0"
                          widthSize="auto"
                          width="120"></pdq-input-arrows>
                      }

                      @if (control.value?.weekday === ExtendedWeekdays.CUSTOM_DATE) {
                        <div class="datepicker-container">
                          <p>Date</p>
                          <!-- [PDQ-TODO:Migrate-To-Storybook] - Migrate to Storybook  -->
                          <app-custom-datepicker
                            [startDate]="control.get('customDate').value.start"
                            [endDate]="control.get('customDate').value.end"
                            (changeDateRange)="handleDateRangeChange($event, control.get('customDate'))"
                            variant="form"></app-custom-datepicker>
                        </div>
                      }
                    </div>
                    <div class="row">
                      <pdq-input-arrows
                        label="Additional shipping cost"
                        [symbol]="shippingMethodCurrency | async | currencySign"
                        formControlName="amount"
                        precision="2"
                        min="0"
                        widthSize="auto"
                        width="120"></pdq-input-arrows>
                      <pdq-input
                        formControlName="shippingName"
                        placeholder="adjust new name"
                        label="Name of delivery method (optional)"
                        width="270"></pdq-input>
                      <pdq-input
                        formControlName="shippingNotes"
                        placeholder="Example: Free for orders above 100$"
                        label="Note on delivery method (optional)"
                        width="270"></pdq-input>
                      @if (i > 0) {
                        <pdq-button class="close-button" (onClick)="removeRule(i)" icon="close"></pdq-button>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
          <pdq-button
            [disabled]="getFormArray()?.value?.length == maxRulesToAdd"
            (onClick)="addRule()"
            label="+Add"></pdq-button>
        </div>
      }
    </div>
  </form>
</div>
